import { defineComponent, computed } from 'vue';
import __vue_component__ from './ItineraryWaypointActionCard.vue.js';
import __vue_component__$1 from './ItineraryWaypointActionsList.vue.js';
import { usePortalStore } from '../../../store/portal/index.js';
import TransitionExpand from '../../../../../transitions/TransitionExpand/TransitionExpand.js';
import { getStore } from '../../../../../../store/helpers/initStore.js';

var script = defineComponent({
    name: 'ItineraryWaypointActionsContainerCard',
    components: {
        ItineraryWaypointActionCard: __vue_component__,
        ItineraryWaypointActionsList: __vue_component__$1,
        TransitionExpand,
    },
    props: {
        waypoint: {
            type: Object,
            required: true,
        },
        waypointID: {
            type: String,
            default: undefined,
        },
        waypointActions: {
            type: Array,
            required: true,
        },
        storeLoading: {
            type: Object,
            required: true,
        },
        hideWorkflow: {
            type: Boolean,
            default: false,
        },
        isActionable: {
            type: Boolean,
            default: true,
        },
        inputDisabled: {
            type: Boolean,
            required: true,
        },
        isCardCollapsed: {
            type: Boolean,
            required: true,
        },
        canCollapse: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['toggleCollapse'],
    setup(props) {
        const store = getStore();
        const portalStore = usePortalStore();
        const getIsSomeProcedureLoading = (wpaID) => {
            var _a;
            const wpa = portalStore.waypointActions.get(wpaID);
            return Object.values((_a = wpa === null || wpa === void 0 ? void 0 : wpa.procedures) !== null && _a !== void 0 ? _a : {}).some((procedure) => { var _a; return !store.state.procedures.procedures[procedure.id] && ((_a = props.storeLoading) === null || _a === void 0 ? void 0 : _a[procedure.id]); });
        };
        const waypointActionsLoading = computed(() => {
            var _a, _b, _c;
            return (_c = (_b = (_a = props.waypoint) === null || _a === void 0 ? void 0 : _a.waypointActions) === null || _b === void 0 ? void 0 : _b.some((wpa) => {
                var _a;
                return !store.state.waypoint.waypointActions[wpa.id]
                    && (((_a = props.storeLoading) === null || _a === void 0 ? void 0 : _a[wpa.id]) || getIsSomeProcedureLoading(wpa.id));
            })) !== null && _c !== void 0 ? _c : false;
        });
        return {
            waypointActionsLoading,
        };
    },
});

export { script as default };
